/* Consulta NFC-e (SP): NFC-e emitidas, pelo SAE NFC-e da SEFAZ-SP (backend /nfce-captura) */
import { apiFetch, API_URL, obterToken } from './apiClient';

const B = '/nfce-captura';
const qs = (p) => {
  const u = new URLSearchParams();
  Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') u.set(k, v); });
  const s = u.toString();
  return s ? `?${s}` : '';
};

export const listarClientesNfce = () => apiFetch(`${B}/clientes`);
export const listarNfces = (filtro) => apiFetch(`${B}/notas${qs(filtro)}`);
export const listarExecucoesNfce = (clienteId) => apiFetch(`${B}/execucoes${qs({ cliente_id: clienteId })}`);
export const sincronizarClienteNfce = (id) => apiFetch(`${B}/clientes/${id}/sincronizar`, { method: 'POST' });
export const executarCapturaNfceTodos = () => apiFetch(`${B}/executar`, { method: 'POST' });
export const sequenciaNfce = (filtro) => apiFetch(`${B}/sequencia${qs(filtro)}`);
export const justificarNfce = (corpo) => apiFetch(`${B}/sequencia/justificar`, { method: 'POST', body: JSON.stringify(corpo) });
export const removerJustificativaNfce = (id) => apiFetch(`${B}/sequencia/justificar/${id}`, { method: 'DELETE' });

export async function baixarNfce(caminho, nomePadrao) {
  const token = obterToken();
  const r = await fetch(`${API_URL}${B}${caminho}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) {
    let msg = 'Erro ao baixar o arquivo';
    try { msg = (await r.json()).error || msg; } catch { /* sem JSON */ }
    throw new Error(msg);
  }
  const nome = (/filename="([^"]+)"/.exec(r.headers.get('content-disposition') || '') || [])[1] || nomePadrao;
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url; a.download = nome;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
export const urlZipNfce = (filtro) => `/zip${qs(filtro)}`;
